import React, { useEffect, useState, useRef } from 'react';
type Reaction = {
  id: number;
  emoji: string;
  left: number; // % from left within the overlay
  size: number; // px
  duration: number; // s
  drift: number; // px horizontal wobble amplitude
  opacity: number;
};
const EMOJIS = ['❤️', '😍', '🔥', '👏'];
/**
 * YouTube/IG-live style floating reactions. Emojis spawn near the bottom and
 * rise to the top with a gentle horizontal wobble while fading out. Purely
 * decorative — pointer-events disabled so it never blocks the video.
 */
type LiveReactionsProps = {
  /** Only spawn new reactions while true (e.g. the first seconds of play). */
  active?: boolean;
};
export function LiveReactions({
  active = true
}: LiveReactionsProps) {
  const [reactions, setReactions] = useState<Reaction[]>([]);
  const idRef = useRef(0);
  useEffect(() => {
    if (!active) return;
    let timeout: number;
    const spawn = () => {
      const id = idRef.current++;
      const reaction: Reaction = {
        id,
        emoji: EMOJIS[Math.floor(Math.random() * EMOJIS.length)],
        left: 60 + Math.random() * 35,
        size: 12 + Math.random() * 16,
        duration: 3.2 + Math.random() * 2.3,
        drift: (Math.random() - 0.5) * 60,
        opacity: 0.65 + Math.random() * 0.35 // 0.65–1
      };
      setReactions(prev => [...prev.slice(-24), reaction]);
      // Remove after it finishes animating.
      window.setTimeout(() => {
        setReactions(prev => prev.filter(r => r.id !== id));
      }, reaction.duration * 1000 + 200);
      timeout = window.setTimeout(spawn, 200 + Math.random() * 300);
    };
    timeout = window.setTimeout(spawn, 150);
    return () => window.clearTimeout(timeout);
  }, [active]);
  return <div className="pointer-events-none absolute inset-0 overflow-hidden z-10" data-id="element-96">
      <style data-id="element-97">{`@keyframes liveFloatUp{0%{transform:translateY(0) translateX(0) scale(.85);opacity:0}10%{opacity:1}55%{transform:translateY(-55%) translateX(var(--drift)) scale(1.05)}100%{transform:translateY(-110%) translateX(calc(var(--drift) * -0.6)) scale(.9);opacity:0}}`}</style>
      {reactions.map(r => <span key={r.id} aria-hidden="true" className="absolute bottom-3 will-change-transform select-none" style={{
      left: `${r.left}%`,
      fontSize: `${r.size}px`,
      opacity: r.opacity,
      // @ts-expect-error custom property
      '--drift': `${r.drift}px`,
      animation: `liveFloatUp ${r.duration}s ease-in forwards`,
      filter: 'drop-shadow(0 2px 4px rgba(0,0,0,0.35))'
    }} data-id="element-98">
          {r.emoji}
        </span>)}
    </div>;
}